import { Cryptocurrency } from '__generated__/globalTypes';
import { CryptoIcon } from 'atoms/icons/CryptoIcon';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LabelM, LabelXS } from 'atoms/typography';
import { Dots } from 'atoms/ui/Dots';
import { useIntlContext } from 'contexts/intl';
import { useCryptoBalance } from 'hooks/useCryptoBalance';

const fallback = {
  [Cryptocurrency.WEI]: '0 ETH',
  [Cryptocurrency.LAMPORT]: '0 SOL',
};

type Props = { collapsed?: boolean };

export const CryptoBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { hideBalance, cryptocurrency, balanceInCrypto, roundedCryptoValue } =
    useCryptoBalance(collapsed);

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <CryptoIcon cryptocurrency={cryptocurrency} />
        <LabelXS bold>
          {hideBalance ? (
            <Dots count={3} size="small" />
          ) : (
            formatNumber(roundedCryptoValue, {
              notation: 'compact',
              compactDisplay: 'short',
              maximumFractionDigits: 2,
            })
          )}
        </LabelXS>
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <CryptoIcon cryptocurrency={cryptocurrency} />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{balanceInCrypto || fallback[cryptocurrency]}</LabelM>
  );
};
